import { Injectable } from '@angular/core';
import PlatformProperties from 'src/plugins/platform-properties/platform-properties.plugin';

@Injectable({
  providedIn: 'root'
})
export class PlatformPropertiesService {
  async getGoogleMapsApiKey(): Promise<string> {
    const apiKeyObj = await PlatformProperties.getGoogleMapsApiKey();
    return apiKeyObj.apiKey;
  }
}
